module.exports = __webpack_public_path__ + "img/editorForm.f0fc57c8.jpg";